import type { Resource } from '../../';
export const cart_cartItem_quantity: Resource = {"default":"Quantity"};
